import { ReactComponent as Empty } from "./InvestorVerificationNeeded.svg";
import { ReactComponent as EmptyEntity } from "../../../../assets/Empty-entity.svg";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import React from "react";
import { useNavigate } from "react-router";
import { VERIFICATION_URL } from "../../routing-constants";
import { InvestorType, InvestorTypes } from "../../../../data/types/investors";
import { GenericContentRestricted } from "../../shared/GenericContentRestricted";

interface InvestorVerificationNeededProps {
  currentPath: string;
  investorType: InvestorType;
  entityName?: string;
}

export const InvestorVerificationNeeded: React.FC<
  InvestorVerificationNeededProps
> = ({ currentPath, investorType, entityName }) => {
  const navigate = useNavigate();
  const isEntity = investorType === InvestorTypes.ENTITY;

  return (
    <GenericContentRestricted
      image={isEntity ? <EmptyEntity /> : <Empty />}
      title={
        <Translate
          translationKey={
            isEntity
              ? TranslationKeys.PROFILE_ENTITY_INFORMATION_EMPTY_TITLE
              : TranslationKeys.PROFILE_PERSONAL_INFORMATION_EMPTY_TITLE
          }
          replacements={isEntity ? { entityName: entityName ?? "" } : {}}
        />
      }
      subtitle={
        <TranslateHtml
          translationKey={
            isEntity
              ? TranslationKeys.PROFILE_ENTITY_INFORMATION_EMPTY_SUBTITLE
              : TranslationKeys.PROFILE_PERSONAL_INFORMATION_EMPTY_SUBTITLE
          }
        />
      }
      comment={
        <TranslateHtml
          translationKey={
            isEntity
              ? TranslationKeys.PROFILE_ENTITY_INFORMATION_EMPTY_COMMENT
              : TranslationKeys.PROFILE_PERSONAL_INFORMATION_EMPTY_COMMENT
          }
        />
      }
      onCTAClick={() => navigate(VERIFICATION_URL(currentPath))}
      ctaText={
        <Translate
          translationKey={
            isEntity
              ? TranslationKeys.PROFILE_ENTITY_INFORMATION_EMPTY_CTA
              : TranslationKeys.PROFILE_PERSONAL_INFORMATION_EMPTY_CTA
          }
        />
      }
    />
  );
};
